"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const react_1 = __importStar(require("react"));
const io_1 = require("react-icons/io");
const react_2 = require("@chakra-ui/react");
exports.Select = react_1.forwardRef(function Select(_a, ref) {
    var { height, isDisabled, isLoading, loadingText, options, placeholder } = _a, rest = __rest(_a, ["height", "isDisabled", "isLoading", "loadingText", "options", "placeholder"]);
    const theme = react_2.useTheme();
    return (react_1.default.createElement(react_2.Select, Object.assign({ bg: "white", borderColor: "lightgray.600", borderRadius: "base", color: "darkgray.700", fontFamily: "secondary", isDisabled: isDisabled || isLoading, height: height || "tall", iconColor: isLoading ? "darkgray.900" : "darkgray.600", icon: isLoading ? react_1.default.createElement(react_2.Spinner, null) : react_1.default.createElement(io_1.IoIosArrowDown, null), iconSize: isLoading ? "sm" : "20px", textStyle: "body1", fontSize: "sm", ref: ref, _disabled: {
            bg: "lightgray.300",
            color: "darkgray.300",
            cursor: "not-allowed",
            _hover: {
                borderColor: "lightgray.600",
            },
        }, _focus: {
            border: `1.5px solid ${theme.colors.primary[500]}`,
            boxShadow: `0px 0px 4px ${theme.colors.primary[500]}!important`,
        }, _hover: {
            borderColor: "darkgray.100",
        } }, rest),
        react_1.default.createElement("option", { value: "", hidden: true, defaultChecked: true, style: { backgroundColor: "#000" } }, isLoading ? loadingText || "Carregando..." : placeholder),
        options.map((opt) => (react_1.default.createElement("option", { key: opt.label, value: opt.value }, opt.label)))));
});
//# sourceMappingURL=Select.js.map